
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Select from "@/components/form/Select.vue";
import AsnModule from "@/store/modules/asn";
import { getModule } from "vuex-module-decorators";
import { AsnLevel } from "@/models/api/asn/asn";
import { AsnFormula } from "@/models/api/asn/formula";
import AsnFormulaLine from "./AsnFormulaLine.vue";

const asnModule = getModule(AsnModule);

import _ from "lodash";
import LookupLine from "./LookupLine.vue";
import { Lookup } from "@/models/api/asn/lookup";

@Component({
    components: {
    Select,
    LookupLine
  }
})
export default class LookupModal extends Vue {

    @Prop({ default: null })
    Lookups: Lookup[];

    @Prop()
    Mappable: string[];

    async onLookupUpdated(lookup: Lookup){
        this.$emit('lookup-updated', lookup);
    }

    async onLookupRemoved(lookup: Lookup){
        this.$emit('lookup-removed', lookup);
    }

    async onLookupAdded(){
        this.$emit('lookup-added');
    }

}
